import moment from 'moment';
export default {
    install(app) {
        app.config.globalProperties.$helper = {

            sayHello(name = "User") {

            },

            isLoggedIn() {
                return !!localStorage.getItem("user");
            },

            formatDate(dateStr) {
                const d = new Date(dateStr);
                return d.toLocaleDateString();
            },

            getFormattedAmount_(sub) {
                var formatter = new Intl.NumberFormat("en-US");
                return formatter.format(sub).replace(".00", "");
            },

            formatAmountMode(value, mode) {
                value = !value ? 0 : value
                let amount = Math.floor(Math.abs(value)); // Whole number part
                let decimal = (value % 1).toFixed(2).split('.')[1]; // Decimal part
                return mode === 1 ? this.getFormattedAmount_(Math.abs(amount)) : decimal;
            },

            formatAmount(amount) {
                var formatter = new Intl.NumberFormat("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });

                var val = formatter.format(amount);
                return amount < 0 ? `(${val.replace("-", "")})` : val
            },

            formattedDate(timestamp) {
                return moment.unix(timestamp).format('MM/DD/YYYY');
            },

            formatDateTime(timestamp) {
                return moment.unix(timestamp).format('MM/DD/YYYY hh:mm A');
            },

            formatDateTimestamp(timestamp, format) {
                return moment.unix(timestamp).format(format);
            },

            isEmpty(value) {
                return (
                    value === null ||
                    value === undefined ||
                    (typeof value === "string" && value.trim() === "") ||
                    (Array.isArray(value) && value.length === 0) ||
                    (typeof value === "object" && Object.keys(value).length === 0)
                );
            },
            formatPhoneNumber(phone) {
                if (!phone || typeof phone !== 'string') return '-';

                // Match phone number in the format +1XXXXXXXXXX
                const match = phone.match(/^\+1(\d{3})(\d{3})(\d{4})$/);
                if (!match) return phone; // If it doesn't match +1XXXXXXXXXX, return as-is

                const [, area, prefix, line] = match;
                return `(${area}) ${prefix}-${line}`;
            },

            extractPhoneNumber(phone) {
                if (this.isEmpty(phone)) {
                    return "";
                } else {
                    return "+1" + phone.replace(/\D/g, "");
                }

            },


            getTimeAgo(date) {
                const createdTime = new Date(date);
                const currentTime = new Date();
                const diffInSeconds = Math.floor((currentTime - createdTime) / 1000);

                const minutes = Math.floor(diffInSeconds / 60);
                const hours = Math.floor(minutes / 60);
                const days = Math.floor(hours / 24);
                const weeks = Math.floor(days / 7);
                const months = Math.floor(days / 30);
                const years = Math.floor(days / 365);

                if (years > 0) return `${years} ${(years > 1 ? `Years` : `Year`)} ago`;
                if (months > 0) return `${months} ${(months > 1 ? `Months` : `Month`)} ago`;
                if (weeks > 0) return `${weeks} ${(weeks > 1 ? `Weeks` : `Week`)} ago`;
                if (days > 0) return `${days}d ago`;
                if (hours > 0) return `${hours}h ago`;
                if (minutes > 0) return `${minutes}m ago`;

                return `just now`;
            },

            getCleanText(htmlString) {
                const div = document.createElement("div");
                div.innerHTML = htmlString;

                // Remove empty tags like <br> and trim spaces
                div.querySelectorAll("br, p:empty, div:empty").forEach(el => el.remove());

                return div.textContent.trim(); // Extract only meaningful text
            },
        };

        app.config.globalProperties.$constants = constants
    }
}

// also export plain constants for non-Vue files
export const constants = {
    EMAIL_REGEX: /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/,
    PASSWORD_REGEX: /^(?!.*\s)(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>[\];'`~+=_-])[A-Za-z\d!@#$%^&*(),.?":{}|<>[\];'`~+=_-]{8,}$/,
    ZIP_CODE_REGEX: /^\d{5}$/,
    APPOINTMENT_TITLE: 'Appointment',
    UQ_TITLE: 'Universal Quote',
    SAR_TITLE: 'Service & Repair',
    CHECKOUT_TITLE: "Checkout"
}